import { FC } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { View } from './components/View';

const EmailPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Envío de correo</PageTitle>
      <View />
    </>
  );
};

export { EmailPage };
